export default {
  apiKey: "AIzaSyB5G2lt0YUHMmXtqGelqpxyj2CZtpBaPGk",
  authDomain: "credentials-check-364ee.firebaseapp.com",
  projectId: "credentials-check-364ee",
  storageBucket: "credentials-check-364ee.appspot.com",
  messagingSenderId: "1002225483321",
  appId: "1:1002225483321:web:1355a51f5d642ddea617e8",
  measurementId: "G-K0F46P697P",
};
